// extracted by mini-css-extract-plugin
module.exports = {"canvas":"App_canvas__pZzp5"};